import IconWrapper from "@components/svg_icon_wrapper"

const SVGComponent = () => (
  <IconWrapper sx={{ width: 25, height: 25 }}>
    <svg
      id="katman_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 130.67 104.11"
      style={{
        //@ts-expect-error enableBackground
        enableBackground: "new 0 0 130.67 104.11"
      }}
      xmlSpace="preserve"
    >
      <style type="text/css">
        {
          "\n\t.st0{fill:#231F1F;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#5D3EBC;}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st5{mask:url(#mask-2_00000165918919317507121320000005926943671838284707_);}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_00000090980961485233087080000011925281929068191394_);}\n\t.st7{mask:url(#mask-4_00000103266070784256892050000008068502585965781648_);fill:#FFD10D;}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000110456974040077068840000008223384139797923735_);}\n\t.st9{mask:url(#mask-6_00000017487881251154754710000012273903602994963386_);fill:#FFD10D;}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_00000099660185974589695740000013400367826579909555_);}\n\t.st11{mask:url(#mask-8_00000020388585935936955710000009950371470604686741_);fill:#FFD10D;}\n\t.st12{filter:url(#Adobe_OpacityMaskFilter_00000172398723220068508610000013232793430344368813_);}\n\t.st13{mask:url(#mask-10_00000133495825899020965280000004096885380160503716_);fill:#FFD10D;}\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_00000161612953154685521310000017214868724404171939_);}\n\t.st15{mask:url(#mask-12_00000084497071802336364500000009640711721156076702_);fill:#FFD10D;}\n\t.st16{filter:url(#Adobe_OpacityMaskFilter_00000168112906322206266170000008532987064021127314_);}\n\t.st17{mask:url(#mask-14_00000108297309815572500320000002567411906446020537_);fill:#FFD10D;}\n\t.st18{filter:url(#Adobe_OpacityMaskFilter_00000057829291237509360460000000670445791561081000_);}\n\t.st19{mask:url(#mask-16_00000040536027894657427840000012795189168895055523_);fill:#FFD10D;}\n\t.st20{filter:url(#Adobe_OpacityMaskFilter_00000134958009593294365630000000874074894770030006_);}\n\t.st21{mask:url(#mask-18_00000095329628417709126120000009752909439822189475_);fill:#231F1F;}\n"
        }
      </style>
      <path
        id="Path"
        className="st0"
        d="M90.04,42.17c1.13-7.81-2.89-15.75-10.39-19.26c-7.5-3.5-16.16-1.48-21.41,4.4 c-10.35,1.5-19.77,8.04-24.51,18.24c-7.49,16.09-0.55,35.2,15.51,42.71s35.14,0.53,42.63-15.56C96.59,62.49,95.54,51.07,90.04,42.17 z"
      />
      <path
        id="Path_00000015356826023900274250000016081945203227550873_"
        className="st0"
        d="M71.96,16.13c1.36,0.64,3.03-0.01,3.71-1.47 c0.68-1.45,0.12-3.14-1.26-3.8c-1.36-0.64-3.03,0.01-3.71,1.47C70.03,13.79,70.6,15.48,71.96,16.13z"
      />
      <path
        id="Path_00000155140589668924725390000004362117825694607241_"
        className="st0"
        d="M89.59,24.36c1.36,0.64,3.03-0.01,3.71-1.47 c0.68-1.45,0.12-3.14-1.26-3.8c-1.36-0.64-3.03,0.01-3.71,1.47C87.66,22.03,88.23,23.72,89.59,24.36L89.59,24.36z"
      />
      <path
        id="Path_00000008146164366254233660000009322649238625052326_"
        className="st1"
        d="M90.04,42.16c1.13-7.81-2.89-15.75-10.39-19.26 c-7.5-3.5-16.16-1.48-21.41,4.4c-10.35,1.5-19.77,8.02-24.51,18.24c-7.49,16.09-0.55,35.2,15.51,42.71 c16.06,7.5,35.14,0.53,42.63-15.56C96.59,62.49,95.54,51.07,90.04,42.16z"
      />
      <path
        id="Path_00000134250469940334259480000013384970312655939000_"
        className="st0"
        d="M88.5,47.3c-4.29,9.19-15.18,13.17-24.35,8.88 c-9.18-4.29-13.14-15.21-8.87-24.39c4.29-9.19,15.18-13.17,24.36-8.88C88.81,27.19,92.78,38.11,88.5,47.3L88.5,47.3z"
      />
      <path
        id="Path_00000046299310960915972910000016031530224949470602_"
        className="st2"
        d="M91.85,72.69 c-7.49,16.09-26.57,23.04-42.63,15.56c-16.06-7.5-23-26.62-15.51-42.71c7.49-16.09,26.57-23.04,42.63-15.56 C92.4,37.48,99.34,56.61,91.85,72.69z"
      />
      <g id="Path_00000183211199603998562570000006913051123731708828_" />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter"
          filterUnits="userSpaceOnUse"
          x={37.51}
          y={28.27}
          width={53.86}
          height={57.97}
        >
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
          />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x={37.51}
        y={28.27}
        width={53.86}
        height={57.97}
        id="mask-2_00000165918919317507121320000005926943671838284707_"
      >
        <g className="st3">
          <path
            id="path-1_00000173152156023362058130000008631056512332541338_"
            className="st4"
            d="M33.72,45.54 c-7.49,16.09-0.55,35.2,15.51,42.71c16.06,7.5,35.14,0.53,42.63-15.56C99.35,56.6,92.41,37.48,76.35,30 c-4.39-2.05-8.99-3.01-13.52-3.01C50.73,26.97,39.16,33.85,33.72,45.54L33.72,45.54z"
          />
        </g>
      </mask>
      <g
        id="Group_00000120542084929990451220000016759358295497183135_"
        className="st5"
      >
        <g id="Clipped" transform="translate(-59.047358, -12.452896)">
          <g>
            <g id="Path_00000149359163594021936060000016732081270706673850_" />
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_00000121269666827891000490000012833108656540248490_"
                filterUnits="userSpaceOnUse"
                x={124.29}
                y={40.72}
                width={16.22}
                height={16.25}
              >
                <feColorMatrix
                  type="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={124.29}
              y={40.72}
              width={16.22}
              height={16.25}
              id="mask-4_00000103266070784256892050000008068502585965781648_"
            >
              <g
                style={{
                  filter:
                    "url(#Adobe_OpacityMaskFilter_00000121269666827891000490000012833108656540248490_)"
                }}
              >
                <polygon
                  id="path-3_00000057827833563559580440000008805877860713330865_"
                  className="st4"
                  points="156.72,20.25 -1.23,20.25  -1.23,106.54 156.72,106.54  "
                />
              </g>
            </mask>
            <path
              id="Path_00000067218465751358956990000009850258535707629190_"
              className="st7"
              d="M139.76,52.28 c-1.9,4.06-6.72,5.83-10.78,3.93c-4.06-1.9-5.81-6.73-3.93-10.8c1.9-4.06,6.72-5.83,10.78-3.93 C139.89,43.38,141.64,48.22,139.76,52.28L139.76,52.28z"
            />
          </g>
          <g>
            <g id="Path_00000085239433222063442750000011029291419363223464_" />
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_00000139277945049929754060000013654961890203822761_"
                filterUnits="userSpaceOnUse"
                x={103.86}
                y={62.47}
                width={12.23}
                height={12.25}
              >
                <feColorMatrix
                  type="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={103.86}
              y={62.47}
              width={12.23}
              height={12.25}
              id="mask-6_00000017487881251154754710000012273903602994963386_"
            >
              <g
                style={{
                  filter:
                    "url(#Adobe_OpacityMaskFilter_00000139277945049929754060000013654961890203822761_)"
                }}
              >
                <polygon
                  id="path-5_00000016033146852085335190000009616362333783974563_"
                  className="st4"
                  points="156.72,20.25 -1.23,20.25  -1.23,106.54 156.72,106.54  "
                />
              </g>
            </mask>
            <path
              id="Path_00000000209283613563902950000000464781131856096162_"
              className="st9"
              d="M115.53,71.19 c-1.42,3.07-5.07,4.39-8.13,2.97c-3.07-1.42-4.39-5.07-2.97-8.14c1.42-3.07,5.07-4.39,8.13-2.97 C115.62,64.48,116.95,68.13,115.53,71.19z"
            />
          </g>
          <g>
            <g id="Path_00000107547652124974369340000008298551101975046805_" />
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_00000075150500318795689250000013778595578690257313_"
                filterUnits="userSpaceOnUse"
                x={104.12}
                y={47.04}
                width={7.61}
                height={7.61}
              >
                <feColorMatrix
                  type="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={104.12}
              y={47.04}
              width={7.61}
              height={7.61}
              id="mask-8_00000020388585935936955710000009950371470604686741_"
            >
              <g
                style={{
                  filter:
                    "url(#Adobe_OpacityMaskFilter_00000075150500318795689250000013778595578690257313_)"
                }}
              >
                <polygon
                  id="path-7_00000126306599141567260460000015644619740710961334_"
                  className="st4"
                  points="156.72,20.25 -1.23,20.25  -1.23,106.54 156.72,106.54  "
                />
              </g>
            </mask>
            <path
              id="Path_00000078022919427853097580000004065566042064548743_"
              className="st11"
              d="M111.38,52.46 c-0.89,1.91-3.14,2.73-5.06,1.84c-1.9-0.89-2.73-3.16-1.84-5.06c0.89-1.91,3.14-2.73,5.06-1.84 C111.45,48.28,112.27,50.54,111.38,52.46z"
            />
          </g>
          <g>
            <g id="Path_00000170267557567487985430000015999493527648146569_" />
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_00000065069720505827201180000007983145497051071397_"
                filterUnits="userSpaceOnUse"
                x={96.56}
                y={78.43}
                width={7.61}
                height={7.61}
              >
                <feColorMatrix
                  type="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={96.56}
              y={78.43}
              width={7.61}
              height={7.61}
              id="mask-10_00000133495825899020965280000004096885380160503716_"
            >
              <g
                style={{
                  filter:
                    "url(#Adobe_OpacityMaskFilter_00000065069720505827201180000007983145497051071397_)"
                }}
              >
                <polygon
                  id="path-9_00000012443097040276298170000008992913684869097913_"
                  className="st4"
                  points="156.72,20.25 -1.23,20.25  -1.23,106.54 156.72,106.54  "
                />
              </g>
            </mask>
            <path
              id="Path_00000015324870141767419880000010434157959948475269_"
              className="st13"
              d="M103.81,83.85 c-0.89,1.91-3.14,2.73-5.06,1.84c-1.9-0.89-2.73-3.16-1.84-5.06c0.89-1.91,3.14-2.73,5.06-1.84 C103.89,79.68,104.7,81.95,103.81,83.85L103.81,83.85z"
            />
          </g>
          <g>
            <g id="Path_00000005246429085664529910000009196879983432990654_" />
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_00000151534056317108748690000012035045887367164088_"
                filterUnits="userSpaceOnUse"
                x={125.6}
                y={72.63}
                width={12.24}
                height={12.25}
              >
                <feColorMatrix
                  type="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={125.6}
              y={72.63}
              width={12.24}
              height={12.25}
              id="mask-12_00000084497071802336364500000009640711721156076702_"
            >
              <g
                style={{
                  filter:
                    "url(#Adobe_OpacityMaskFilter_00000151534056317108748690000012035045887367164088_)"
                }}
              >
                <polygon
                  id="path-11_00000039103858297579354420000004442561001416120969_"
                  className="st4"
                  points="156.72,20.25 -1.23,20.25  -1.23,106.54 156.72,106.54  "
                />
              </g>
            </mask>
            <path
              id="Path_00000014604706186073215470000011699603026861577883_"
              className="st15"
              d="M126.18,76.17 c-1.42,3.07-0.1,6.72,2.97,8.14c3.07,1.42,6.7,0.1,8.13-2.97c1.42-3.07,0.1-6.72-2.97-8.14C131.25,71.78,127.6,73.1,126.18,76.17 z"
            />
          </g>
          <g>
            <g id="Path_00000178926058758029054590000004987165486614158014_" />
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_00000165203402608889117110000011995711448443990446_"
                filterUnits="userSpaceOnUse"
                x={142.81}
                y={65.11}
                width={7.61}
                height={7.61}
              >
                <feColorMatrix
                  type="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={142.81}
              y={65.11}
              width={7.61}
              height={7.61}
              id="mask-14_00000108297309815572500320000002567411906446020537_"
            >
              <g
                style={{
                  filter:
                    "url(#Adobe_OpacityMaskFilter_00000165203402608889117110000011995711448443990446_)"
                }}
              >
                <polygon
                  id="path-13_00000049189058623328231150000009656166341928114066_"
                  className="st4"
                  points="156.72,20.25 -1.23,20.25  -1.23,106.54 156.72,106.54  "
                />
              </g>
            </mask>
            <path
              id="Path_00000176009881981511036190000012790201550208152211_"
              className="st17"
              d="M143.17,67.3 c-0.89,1.91-0.06,4.17,1.84,5.06c1.9,0.89,4.17,0.06,5.06-1.84c0.89-1.91,0.06-4.17-1.84-5.06 C146.31,64.57,144.06,65.4,143.17,67.3L143.17,67.3z"
            />
          </g>
          <g>
            <g id="Path_00000085230908201909322630000001708823370062565819_" />
            <defs>
              <filter
                id="Adobe_OpacityMaskFilter_00000156560768976003177760000002181503330756104605_"
                filterUnits="userSpaceOnUse"
                x={123.65}
                y={91.08}
                width={7.61}
                height={7.61}
              >
                <feColorMatrix
                  type="matrix"
                  values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={123.65}
              y={91.08}
              width={7.61}
              height={7.61}
              id="mask-16_00000040536027894657427840000012795189168895055523_"
            >
              <g
                style={{
                  filter:
                    "url(#Adobe_OpacityMaskFilter_00000156560768976003177760000002181503330756104605_)"
                }}
              >
                <polygon
                  id="path-15_00000066486603936659244910000014266329041216303011_"
                  className="st4"
                  points="156.72,20.25 -1.23,20.25  -1.23,106.54 156.72,106.54  "
                />
              </g>
            </mask>
            <path
              id="Path_00000005244987231061684480000014864101761116555400_"
              className="st19"
              d="M124.01,93.28 c-0.89,1.91-0.06,4.17,1.84,5.06c1.9,0.89,4.17,0.06,5.06-1.84c0.89-1.91,0.06-4.17-1.84-5.06 C127.17,90.55,124.9,91.38,124.01,93.28L124.01,93.28z"
            />
          </g>
        </g>
      </g>
      <g id="Path_00000080174675794179935360000017274081611084566172_" />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000070119981850576774350000015538002588342393476_"
          filterUnits="userSpaceOnUse"
          x={48.03}
          y={29.24}
          width={29.32}
          height={60.13}
        >
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
          />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x={48.03}
        y={29.24}
        width={29.32}
        height={60.13}
        id="mask-18_00000095329628417709126120000009752909439822189475_"
      >
        <g
          style={{
            filter:
              "url(#Adobe_OpacityMaskFilter_00000070119981850576774350000015538002588342393476_)"
          }}
        >
          <path
            id="path-17_00000175294861939972693290000006860272242055881101_"
            className="st4"
            d="M33.72,45.54 c-7.49,16.09-0.55,35.2,15.51,42.71c16.06,7.5,35.14,0.53,42.63-15.56c7.49-16.09,0.55-35.2-15.51-42.71 c-4.39-2.05-8.99-3.01-13.52-3.01C50.73,26.97,39.16,33.85,33.72,45.54L33.72,45.54z"
          />
        </g>
      </mask>
      <path
        id="Path_00000135683423756283446520000006884452068332207540_"
        className="st21"
        d="M76.51,29.61c-0.28-0.13-0.56-0.25-0.86-0.37 L48.03,88.58c0.28,0.13,0.55,0.28,0.83,0.42c0.28,0.13,0.56,0.25,0.86,0.37l27.63-59.36C77.08,29.88,76.8,29.74,76.51,29.61z"
      />
    </svg>
  </IconWrapper>
)

export default SVGComponent
